import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../img/2solve.svg";
import LogoCurta from "../../img/2s.svg";
import "./sidebar-stylesheet.css";
import { Link } from "react-router-dom";
import ModalExport from "../../components/modalExport";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import IconToSolve from "../../components/icon";

function Sidebar({ toggleSidebar, sidebarOpen }) {
  const { t } = useTranslation();

  const [expandedButtons, setExpandedButtons] = useState({
    1: true,
    2: false,
  });
  const [showModalExport, setShowModalExport] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleWindowResize = () => {
      if (window.innerWidth < 768) {
        toggleSidebar(false);
      }
    };

    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, [toggleSidebar]);

  const handleExpand = (index) => {
    setExpandedButtons((prevState) => ({
      1: index === 1 ? !prevState[1] : false,
      2: index === 2 ? !prevState[2] : false,
    }));
  };

  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const handleLinkClick = () => {
    if (window.innerWidth < 768 && sidebarOpen) {
      toggleSidebar(false);
    }
  };

  const routeNames = {
    "/": t("Home"),
    "/alarmes/dashboard/temporeal": t("Alarmes"),
    // "/forecast": t("Forecast"),
    "/variaveis": t("Variáveis"),
    "/ativos": t("Ativos"),
    "/alarmes-cadastro": t("Alarmes Cadastro"),
    "/usuarios": t("Usuários"),
    // "/relatorios": t("Relatórios"),
  };

  const openModalExport = () => {
    setShowModalExport(true);
  };

  const closeModalExport = () => {
    setShowModalExport(false);
  };

  return (
    <>
      <ModalExport show={showModalExport} onHide={closeModalExport} />
      <Navbar className={`col-3 sidebar ${sidebarOpen ? "" : "collapsed"}`}>
        <Navbar.Collapse id="sidebar-nav" className="col-3">
          <br />
          <div className="sidebar-texto">
            <Button
              onClick={() => handleExpand(1)}
              variant="link"
              className="sidebar-group"
            >
              <div className="sidebar-dropdown "> {t("Dashboard")}</div>
              {expandedButtons[1] ? (
                <i className="bi bi-chevron-up sidebar-icon-dropdown" />
              ) : (
                <i className="bi bi-chevron-down sidebar-icon-dropdown" />
              )}
            </Button>

            {expandedButtons[1] && (
              <>
                <div className="sidebar-filhos">
                  <Link
                    to="/"
                    className={`rota sidebar-filho ${
                      isActive("/") ? "pagatual" : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <div className=" d-flex align-items-center ">
                      <IconToSolve
                        className={""}
                        iconName={"Home"}
                        width={35}
                        height={35}
                      />{" "}
                      <div className="sidebar-log">{t("Home")}</div>
                    </div>
                  </Link>

                  <Link
                    to="/alarmes/dashboard/temporeal"
                    className={`rota sidebar-filho ${
                      isActive("/alarmes") ? "pagatual" : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <div className=" d-flex align-items-center ">
                      <IconToSolve
                        className={""}
                        iconName={"Sirene"}
                        width={35}
                        height={35}
                      />{" "}
                      <div className="sidebar-log">{t("Alarmes")}</div>
                    </div>
                  </Link>
                  {/* <Link
                    to="/forecast"
                    className={`rota sidebar-filho ${
                      isActive("/forecast") ? "pagatual" : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <div className=" d-flex align-items-center ">
                      <IconToSolve
                        className={""}
                        iconName={"GraficoSeta"}
                        width={35}
                        height={35}
                      />{" "}
                      <div className="sidebar-log">{t("Forecast")}</div>
                    </div>
                  </Link> */}
                </div>
              </>
            )}

            <Button
              onClick={() => handleExpand(2)}
              variant="link"
              className="sidebar-group"
            >
              <div className="sidebar-dropdown">{t("Cadastro")}</div>
              {expandedButtons[2] ? (
                <i className="bi bi-chevron-up sidebar-icon-dropdown" />
              ) : (
                <i className="bi bi-chevron-down sidebar-icon-dropdown" />
              )}
            </Button>

            {expandedButtons[2] && (
              <>
                <div className="sidebar-filhos">
                  <Link
                    to="/variaveis"
                    className={`rota sidebar-filho ${
                      isActive("/variaveis") ? "pagatual" : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <div className=" d-flex align-items-center ">
                      <IconToSolve
                        className={""}
                        iconName={"Variavel"}
                        width={35}
                        height={35}
                      />
                      <div className="sidebar-log">{t("Variáveis")}</div>
                    </div>
                  </Link>

                  <Link
                    to="/ativos"
                    className={`rota sidebar-filho ${
                      isActive("/ativos") ? "pagatual" : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <div className=" d-flex align-items-center ">
                      <IconToSolve
                        className={""}
                        iconName={"Caminhao"}
                        width={35}
                        height={35}
                      />{" "}
                      <div className="sidebar-log">{t("Ativos")}</div>
                    </div>
                  </Link>

                  <Link
                    to="/alarmes-cadastro"
                    className={`rota sidebar-filho ${
                      isActive("/alarmes-cadastro") ? "pagatual" : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <div className=" d-flex align-items-center ">
                      <IconToSolve
                        className={""}
                        iconName={"Alarme"}
                        width={35}
                        height={35}
                      />{" "}
                      <div className="sidebar-log">{t("Alarmes")}</div>
                    </div>
                  </Link>

                  <Link
                    to="/usuarios"
                    className={`rota sidebar-filho ${
                      isActive("/usuarios") ? "pagatual" : ""
                    }`}
                    onClick={handleLinkClick}
                  >
                    <div className=" d-flex align-items-center ">
                      <IconToSolve
                        className={""}
                        iconName={"Usuario"}
                        width={35}
                        height={35}
                      />{" "}
                      <div className="sidebar-log">{t("Usuários")}</div>
                    </div>
                  </Link>
                </div>
              </>
            )}
            {/* <Link to="/relatorios" className="rota" onClick={handleLinkClick}>
              <div
                className={`sidebar-group-log ${
                  isActive("/relatorios") ? "pagatual" : ""
                }`}
              >
                <div className=" d-flex align-items-center ">
                  <IconToSolve
                    className={""}
                    iconName={"Log"}
                    width={35}
                    height={35}
                  />{" "}
                  <div className="sidebar-log">{t("Relatórios")}</div>
                </div>
              </div>
            </Link> */}
            <Link
              className={"rota sidebar-filho "}
              onClick={() => {
                openModalExport();
              }}
            >
              <div className=" d-flex align-items-center ">
                <IconToSolve
                  className={""}
                  iconName={"Download"}
                  width={35}
                  height={35}
                />{" "}
                <div className="sidebar-log">{t("Exportar")}</div>
              </div>
            </Link>
          </div>
          <div className="sidebar-filhos-recolhido">
            {Object.keys(routeNames).map((path) => (
              <OverlayTrigger
                key={path}
                placement="right"
                delay={{ show: 10 }}
                overlay={
                  <Tooltip id={`tooltip-${path}`}>{routeNames[path]}</Tooltip>
                }
              >
                <Link
                  to={path}
                  className={`rota ${
                    sidebarOpen ? "hide" : "btn-menu-recolhido"
                  } ${isActive(path) ? "pagatual-icn" : ""}`}
                  onClick={handleLinkClick}
                >
                  <IconToSolve
                    className={`${sidebarOpen ? "hide" : "show"}`}
                    iconName={getIconName(path)}
                    width={35}
                    height={35}
                  />
                </Link>
              </OverlayTrigger>
            ))}
            <OverlayTrigger
              placement="right"
              delay={{ show: 10 }}
              overlay={<Tooltip id="tooltip-exportar">{t("Exportar")}</Tooltip>}
            >
              <Button
                variant="link"
                className={`rota btn-recolhido-export ${
                  sidebarOpen ? "hide" : "btn-menu-recolhido "
                }`}
                onClick={openModalExport}
              >
                <IconToSolve
                  className={""}
                  iconName={"Download"}
                  width={35}
                  height={35}
                />
              </Button>
            </OverlayTrigger>
          </div>
          <Button
            title="Fechar sidebar"
            onClick={() => {
              toggleSidebar();
            }}
            className={`toggle-sidebar-button btn-menu-fechado collapsed${
              sidebarOpen ? "hide" : ""
            }`}
          >
            <i
              className={`bi btn-menu-icn ${
                sidebarOpen ? "bi-caret-left" : "bi-caret-right"
              }`}
            ></i>
          </Button>
          <div className="sidebar-filhos sidebar-img">
            <img
              src={sidebarOpen ? Logo : LogoCurta}
              alt={sidebarOpen ? "Logo 2S" : "Logo 2S"}
              className={` ${
                sidebarOpen ? "sidebar-logo" : "img-sidebar-short"
              }`}
              width="100%"
              height="100%"
            />
          </div>
        </Navbar.Collapse>
      </Navbar>
    </>
  );

  function getIconName(path) {
    switch (path) {
      case "/":
        return "Home";
      case "/alarmes/dashboard/temporeal":
        return "Sirene";
      case "/variaveis":
        return "Variavel";
      case "/ativos":
        return "Caminhao";
      case "/alarmes-cadastro":
        return "Alarme";
      case "/usuarios":
        return "Usuario";
      // case "/relatorios":
      //   return "Log";
      // case "/forecast":
      //   return "GraficoSeta";
      default:
        return "";
    }
  }
}
Sidebar.propTypes = {
  toggleSidebar: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
};

export default Sidebar;
